/* batida-konto-kody.js: "Twoje kody" in Moje konto (sections/batida-konto-kody.liquid; phase 2, 29.09).
   Active, unused reward codes from Batida Connect (GET /apps/connect/konto -> rewards: [{code, percent, validUntil,
   source, used}]), with "Kopiuj". The cart applies an active code by itself (assets/batida-konto-cart.js), so the box
   says so. No active code = no box. Registers with the panel (assets/batida-konto.js, window.BatidaKontoQ). */
(function () {
  'use strict';
  var el = document.querySelector('[data-v7k-feat="kody"]');
  if (!el) return;
  var F; try { F = JSON.parse(el.textContent); } catch (e) { return; }
  var T = F.t || {};
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function tx(k, vars) { return esc(T[k] || '').replace(/\{(\w+)\}/g, function (m, n) { return vars && vars[n] != null ? vars[n] : ''; }); }
  var wired = false;

  (window.BatidaKontoQ = window.BatidaKontoQ || []).push({ id: 'kody', render: function (ctx) {
    var slot = ctx.slot('start', 'kody');
    if (!slot) return;
    var c = ctx.connect, h = ctx.h;
    /* Connect lists only unexpired codes (validUntil = the last valid day, inclusive), unused first, used ones after */
    var list = (F.on || ctx.DEMO) && c && Array.isArray(c.rewards) ? c.rewards.filter(function (r) {
      var until = h.normYmd(r && r.validUntil);
      return r && r.code && (!until || until >= ctx.TODAY);
    }) : [];
    if (!list.some(function (r) { return !r.used; })) { slot.innerHTML = ''; return; }
    var rows = list.map(function (r) {
      var until = h.normYmd(r.validUntil);
      var bits = [];
      if (r.percent) bits.push(tx('pct', { procent: esc(r.percent) }));
      else if (r.amount) bits.push(tx('amt', { kwota: esc(h.money(Math.round(Number(r.amount) * 100))) }));
      if (until) bits.push(tx('valid', { data: esc(h.dmy(until)) }));
      if (r.source === 'quiz' && T.src_quiz) bits.push(tx('src_quiz'));
      if (r.source === 'birthday' && T.src_birthday) bits.push(tx('src_birthday'));
      if (r.used) return '<div class="v7k-code is-used"><div><b class="v7k-code__c">' + esc(r.code) + '</b><div class="v7k-small">' + bits.join(' · ') + '</div></div><span class="v7k-chip">' + tx('used') + '</span></div>';
      return '<div class="v7k-code"><div><b class="v7k-code__c">' + esc(r.code) + '</b><div class="v7k-small">' + bits.join(' · ') + '</div></div>' +
        '<button type="button" class="v7k-btn v7k-btn--sm" data-v7k-copy="' + esc(r.code) + '">' + tx('copy') + '</button></div>';
    }).join('');
    slot.innerHTML = h.box('s12 v7k-codes', '<h2 class="v7k-h2">' + tx('title') + '</h2><p class="v7k-sub">' + tx('sub') + '</p><div class="v7k-codes__list">' + rows + '</div>');
    if (!wired) {
      wired = true;
      ctx.app.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-v7k-copy]'); if (!b) return;
        var code = b.getAttribute('data-v7k-copy');
        var done = function () { h.toast(T.copied || code); };
        try { navigator.clipboard.writeText(code).then(done, function () { h.toast(code); }); } catch (x) { h.toast(code); }
      });
    }
  } });
})();
